/**
 * todoCreateInput — the ONE translation from a create draft to the
 * POST /api/todos body (the to-dos upgrade, 2026-10-04).
 *
 * Three surfaces create through `TodoCreateContainer` with their own write —
 * the to-dos page / the top bar's "+ Add a to-do" (TodoCreateHost), a card's
 * "+ todo" (CreateTodoDialog) and the client file (TodoDetailModal's create
 * adapter). Each used to build the body by hand, so a field added to the draft
 * reached one of them and silently not the others. Team, the suggested-date
 * flag, the repeat rule, the contact and the linked record all go through here.
 */
import type { CreateTodoInput } from '../../services/todosApi';
import type { TodoCreateDraft } from './TodoCreateContainer';
import { repeatPayload } from './todoRepeat';

export function createInputFromDraft(draft: TodoCreateDraft, base: Partial<CreateTodoInput> = {}): CreateTodoInput {
  const rp = draft.repeat ? repeatPayload(draft.repeat) : null;
  const rec = draft.record;
  return {
    ...base,
    title: draft.title,
    task_type: draft.task_type,
    due_date: draft.due_date,
    due_suggested: !!draft.due_date && draft.due_suggested,
    assigned_to: draft.assignee_id,
    description: draft.instructions || undefined,
    client_card_id: draft.client_card_id ?? base.client_card_id ?? undefined,
    ...(draft.team_explicit ? { team: draft.team } : {}),
    ...(rp ? { recurrence_type: rp.recurrence_type, recurrence_config: rp.recurrence_config } : {}),
    ...(draft.contact_id != null ? { contact_id: draft.contact_id } : {}),
    // A record picked here wins over the card the create was opened from: the
    // person re-pointed it on purpose.
    ...(rec ? { source_type: rec.source_type, source_id: rec.source_id } : {}),
    ...(draft.department ? { department: draft.department } : {}),
  };
}

export default createInputFromDraft;
